import { render, staticRenderFns } from "./delcomment-pop.vue?vue&type=template&id=4043ac47&scoped=true&"
import script from "./delcomment-pop.vue?vue&type=script&lang=js&"
export * from "./delcomment-pop.vue?vue&type=script&lang=js&"
import style0 from "./delcomment-pop.vue?vue&type=style&index=0&id=4043ac47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043ac47",
  null
  
)

export default component.exports